import { css } from 'aphrodite';
import * as React from 'react';
import { ChangeEvent, useEffect, useState } from 'react';
import { InputField } from '../../InputField';
import { styleSheet } from './../styles';

interface IProps {
	isRequired?: boolean;
	isHalf?: boolean;
	label: string;
	name: string;
	onChange: (param: { name: string; value: string }) => void;
	value?: string;
}

export const TextFieldType: React.FC<IProps> = ({ isHalf, isRequired, label, name, onChange, value }) => {
	const [innerValue, setValue] = useState<string>(null);

	useEffect(() => {
		setValue(value);
	}, [value]);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		setValue(e.target.value);
		onChange({ name, value: e.target.value });
	};

	return (
		<InputField
			className={css([styleSheet.fieldContainer, isHalf && styleSheet.fieldContainerHalf])}
			handler={handleChange}
			id={name}
			label={
				<span>
					{label} {isRequired && <sup>*</sup>}
				</span>
			}
			value={innerValue}
		/>
	);
};
